/*商品ページのJavaScript  */
/*使用テンプレ：  main-product.liquid*/


window.addEventListener('load', () => {
  
/*商品説明のアコーディオン*/
    const cstmAccordions = document.querySelectorAll(".cstm_js_accordion");

 if (cstmAccordions) {
    for (let i = 0; i < cstmAccordions.length; i++) {
        let cstmAccordion = cstmAccordions[i];
        cstmAccordion.addEventListener('click', () => {
            cstmAccordion.classList.toggle('is_accordion');
        });
    }
    }
  
   /*商品情報の公式情報がなければ非表示 */
      const officialInfo = document.getElementById('cstm_product__official-info');
      const officialInfoTxtElement = document.getElementById('cstm_product__official-info-txt');
      const remarks = document.getElementById('cstm_product__remarks-info');
        console.log(officialInfo);
        console.log(officialInfoTxtElement);
  
      if (officialInfo && officialInfoTxtElement) {
          const officialInfoText = officialInfoTxtElement.textContent;
      
          if (!officialInfoText.trim()) {
              officialInfo.style.display = 'none';
              remarks.style.borderBottom = 'unset';
          }
      } else {
          console.log('公式情報なし');
      }




  
});
